import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import { EventType } from '@wix/editor-platform-sdk-types';

export function openAddElementsPanelIfExist(
  documentServices: DocumentServicesObject,
  componentRef: CompRef,
) {
  const { applicationId } =
    documentServices.components.data.get(componentRef) ?? {};

  const addElementsAction =
    documentServices.platform.controllers.getStageData(componentRef)?.gfpp
      ?.desktop?.iconButtons?.add;

  const shouldOpenPanel = addElementsAction && applicationId;

  if (shouldOpenPanel) {
    documentServices.platform.notifyApplicationByAppDefId(applicationId, {
      eventPayload: {
        componentRef,
        id: addElementsAction.actionId,
      },
      eventType: EventType.widgetGfppClicked,
    });
  }

  return shouldOpenPanel;
}
